import type { SvgIconComponent } from "@mui/icons-material";
import { Card, CardContent, Typography, Box } from "@mui/material";

export type CountCardProps = {
  title: string;
  value: number | string;
  icon: SvgIconComponent;
  color?: "primary" | "success" | "secondary";
};

export default function CountCard({ title, value, icon: Icon, color = "primary" }: CountCardProps) {
  return (
    <Card elevation={2}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mt: 1,
                fontWeight: 700,
                color: "text.primary",
              }}
            >
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: `${color}.light`,
              borderRadius: "50%",
              p: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon sx={{ fontSize: 32, color: "common.white" }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
